import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'agency',
})
export default class Agency extends BaseEntity {
  name: string = '';
  description: string = '';
  isActive: boolean = true;

  constructor(
    id?: Agency['id'],
    name: Agency['name'] = '',
    description: Agency['description'] = '',
    isActive: Agency['isActive'] = false
  ) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.isActive = isActive;
  }
}
